import { call, put, takeEvery } from "redux-saga/effects";

import { LeaveTypeSucess, LeaveTypeFailure } from "store/actions/Timeoff/LeaveTypes";

import { LEAVE_TYPES } from "store/constants/Timeoff";

import getRequest from "util/APIHelperGet";
import { baseUrl } from "util/APIBaseUrl";

export const fetcheLeavesTypesRequest = async ({ payload }) => {
  const loggedInUserID = JSON.parse(localStorage.getItem("loggedInUser"))?.userId;

  let url;
  if (payload?.futureCycleFlag && payload?.flag) {
    // PRD-442: V4 includes next cycle data
    url = `${baseUrl}/v4/employee/${loggedInUserID}/leave_types`;
  } else if (payload?.flag) {
    url = `${baseUrl}/v2/employee/${loggedInUserID}/leave_types`;
  } else {
    url = `${baseUrl}/employee/${loggedInUserID}/leave_types`;
  }

  return await getRequest(url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchLeaveTypes(params) {
  try {
    const response = yield call(fetcheLeavesTypesRequest, params);
    yield put(LeaveTypeSucess(response));
  } catch (error) {
    console.error(error);
    yield put(LeaveTypeFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(LEAVE_TYPES, fetchLeaveTypes);
}
